import { useState, ChangeEvent } from "react";
import useDebouncedValue from "./useDebouncedValue";

interface UseSearchFilterOptions {
  onDebounce?: () => void;
  delay?: number;
}

export const useSearchFilter = (
  options: UseSearchFilterOptions = {}
): {
  search: string;
  debouncedSearch: string;
  handleSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
} => {
  const [search, setSearch] = useState<string>("");

  const debouncedSearch = useDebouncedValue(search, {
    onDebounce: options.onDebounce,
    delay: options.delay ?? 300,
  });

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  return { search, debouncedSearch, handleSearchChange };
};
